import { render, staticRenderFns } from "./MenuTypeDialog.vue?vue&type=template&id=da83c0d4&scoped=true"
import script from "./MenuTypeDialog.vue?vue&type=script&lang=js"
export * from "./MenuTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./MenuTypeDialog.vue?vue&type=style&index=0&id=da83c0d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da83c0d4",
  null
  
)

export default component.exports